import script from "./sw-item-parts-numeric.vue?vue&type=script&setup=true&lang=js"
export * from "./sw-item-parts-numeric.vue?vue&type=script&setup=true&lang=js"

import "./sw-item-parts-numeric.vue?vue&type=style&index=0&id=339db8cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-339db8cc"]])

export default __exports__